import { cn } from "@/utils/cn"

interface RiskScoreBadgeProps {
  score: number
  size?: 'sm' | 'md' | 'lg'
  showLabel?: boolean
  className?: string
}

export const RiskScoreBadge = ({ 
  score, 
  size = 'md', 
  showLabel = false,
  className 
}: RiskScoreBadgeProps) => {
  const getRiskLevel = (score: number) => {
    if (score >= 81) return { 
      level: 'Critical', 
      color: 'bg-risk-critical text-white border-risk-critical/20', 
      pulse: true 
    }
    if (score >= 61) return { 
      level: 'High', 
      color: 'bg-risk-high text-white border-risk-high/20', 
      pulse: false 
    }
    if (score >= 31) return { 
      level: 'Medium', 
      color: 'bg-risk-medium text-white border-risk-medium/20', 
      pulse: false 
    }
    return { 
      level: 'Low', 
      color: 'bg-risk-low text-white border-risk-low/20', 
      pulse: false 
    }
  }
  
  const risk = getRiskLevel(score)
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  }
  
  return (
    <span 
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-medium border transition-all duration-200",
        sizeClasses[size],
        risk.color,
        risk.pulse && 'animate-pulse',
        className
      )}
      role="status"
      aria-label={`Risk score ${score} - ${risk.level} risk`}
    >
      <span className="font-semibold">{score}</span>
      {showLabel && (
        <span className="text-xs opacity-90">{risk.level}</span>
      )}
    </span>
  )
}